/* eslint-disable no-console */
import merge from 'deepmerge'
import { fetcher as rawFetcher } from '@nfinite/react-hubstairs/helpers'
import { parse } from 'qs'

import config from 'utils/config'

const API_ROOT = '/api'
export const API_VERSION = `v3`
const ENVIRONMENT = config.get('ENVIRONMENT')

export function fetcher(url, params = {}) {
  const applicationParams = {
    prefixUrl: `${getUrlApi()}/${API_VERSION}`,
    credentials: 'include',
  }

  // deepmerge loses formData in the body parameter
  return rawFetcher(url, { ...merge(applicationParams, params), body: params.body })
}

export function proxifiedUrl(url) {
  const urlObject = new URL(url)
  const { protocol, hostname, port } = window.location
  urlObject.protocol = protocol
  urlObject.hostname = hostname
  urlObject.port = port
  urlObject.pathname = urlObject.pathname.startsWith(API_ROOT) ? urlObject.pathname : `${API_ROOT}${urlObject.pathname}`
  return urlObject.toString()
}

export function getUrlApi() {
  if (ENVIRONMENT !== 'production') {
    // try getting url from qs
    const { urlApi } = parse(window.location.search, { ignoreQueryPrefix: true })

    if (urlApi) {
      localStorage.setItem('urlApi', urlApi)
      return urlApi
    }

    // try getting url from storage
    const storage = localStorage.getItem('urlApi')
    if (storage) {
      return storage
    }
  }
  // default
  return `${API_ROOT}`
}
